<template>
    <div class="footter">
        <div class="footer-content">
            <div class="title">
                <img src="../assets/logo-footer.webp" alt="logo" />
            </div>
            <div class="bottom">
                <div class="item">
                    <img src="../assets/footer-icon1.webp" alt="" class="icon">
                    <div class="text">+66 0629052187</div>
                </div>
                <div class="item">
                    <img src="../assets/footer-icon2.webp" alt="" class="icon">
                    <div class="text">devops@sapmankongworld.com</div>
                </div>
                <div class="item">
                    <img src="../assets/footer-icon3.webp" alt="" class="icon">
                    <div class="text">7/12 ซอยลาดพร้าว 69 แขวงสะพานสอง เขตวังทองหลาง กรุงเทพมหานคร 10310</div>
                </div>
            </div>
        </div>
        <div class="c">
            © 2026 สงวนลิขสิทธิ์ SUPMANKHONG PUNLARN COMPANY LIMITED
        </div>
    </div>
</template>
<script setup>
</script>
<style lang="less" scoped>
.footter {
    width: 100%;
    height: 291px;
    background: #333333;
    padding: 48px 270px 0;
    box-sizing: border-box;

    .footer-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 45px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.5);
        margin-bottom: 14px;

        .title {
            width: 323px;
            height: 60px;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        .bottom {

            .item {
                display: flex;
                align-items: center;
                margin-bottom: 26px;

                .icon {
                    width: 15px;
                    height: 18px;
                    object-fit: contain;
                    margin-right: 6px;
                }

                .text {
                    max-width: 293px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #FFFFFF;
                    line-height: 20px;
                    text-shadow: 0px 1px 0px #333333;
                }
            }
        }
    }

    .c {
        font-weight: 400;
        font-size: 12px;
        color: #FFFFFF;
        line-height: 18px;
        text-shadow: 0px 1px 0px #333333;
        text-align: center;
    }
}
</style>